import { Dispatch, SetStateAction } from 'react';
import { ServiceLocation, OpeningSchedule } from '@commerce-fulfillment-webcomponents/sdk';
export interface IpropServiceLocationAddress {
  address?: {
    long?: string;
  };
}

export interface AmwayShopCollections {
  /**
   *
   * @type {Array<FulfillmentType>}
   * @memberof AmwayShopCollections
   */
  serviceLocations?: Array<ServiceLocation>;
}

export interface IShopOptionRadioCardProps {
  cardData: IShopsOptions;
  isSelected: boolean;
  showAvailabilityTag?: boolean;
  onCardClickCallback?: (args: string) => void;
  distance?: string;
  setSelectedShop: Dispatch<SetStateAction<string>>;
  shopDetails: (args: IShopsOptions) => void;
}

export interface GoogleMapsLayoutProps {
  setSelectedShop: Dispatch<SetStateAction<string>>;
  shopLocations?: IShopsOptions[];
  selectedShop: string;
}

export interface ShopLayoutProps {
  setSelectedShop: Dispatch<SetStateAction<string>>;
  shopLocations?: IShopsOptions[];
  selectedShop: string;
  availableShops?: number;
  shopDetails: (args: IShopsOptions) => void;
  isLocationAccessAllowed: boolean;
}

export interface SearchFieldProps {
  handleSearchShop: (value: string) => void;
  searchText: string;
  handleSearchClearButton: () => void;
}

export interface IShopsOptions {
  name: string;
  phone?: string;
  addressLine: string;
  openTimingsWeekDay?: string;
  openTimingsWeekend?: string;
  id: string;
  contact: string;
  allItemsAvailable?: boolean;
  schedule: OpeningSchedule;
  serviceLocation?: ServiceLocation;
  lat?: number;
  lng?: number;
}

export interface IShopFinderContainerProps {
  shopLocations?: IShopsOptions[];
  isLocationAccessAllowed: boolean;
}

export enum DataTypesEnums {
  TYPE_STRING = 'TYPE_STRING',
  TYPE_NUMBER = 'TYPE_NUMBER',
}
type DayOfWeek = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export const dayLabels: DayOfWeek[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
